<template>
  <el-table :data="users">
    <el-table-column prop="id" label="ID"> </el-table-column>
    <el-table-column prop="screen_name" label="用户名"> </el-table-column>
    <el-table-column prop="role" label="用户权限" :formatter="roleCNFormatter">
    </el-table-column>
  </el-table>
</template>

<script>
import { RoleCNMixin } from "../mixins";
export default {
  name: "UsersListAdminTable",
  props: ["users"],
  mixins: [RoleCNMixin]
};
</script>
